<template lang="html">
  <div style="margin-top: 15px">
      <canvas ref="canvas"></canvas>
      <span v-html="legend" class="pacing-legend"></span>
  </div>
</template>

<script>
// import Chart from 'chart.js';

export default {
    data() {
        return {
            pacingChart: null,
            legend: '',
        }
    },

    created() {
        Bus.$on('load-daily-client-metrics-chart', this.load);
    },

    methods: {
        load(client) {
            if (this.pacingChart !== null) {
                let context = this.$refs.canvas.getContext('2d');
                context.clearRect(0,0,0,0);
                this.pacingChart.destroy();
            }
            this.fetchData(client);
        },

        fetchData(client) {
            axios.get(`/api/pacing/${client}/daily`)
                .then((response) => {
                    this.renderChart(response);
                }).catch((error) => console.log(error));
        },

        renderChart(response) {
            let sendEvent = true;
            this.pacingChart = new Chart(
                this.$refs.canvas.getContext('2d'), {
                    type: 'line',
                    data: {
                        labels: response.data.days,
                        datasets: [{
                            label: 'Spend',
                            backgroundColor: "rgba(0, 155, 215, 0.5)",
                            borderColor: "rgba(0, 155, 215, 0.8)",
                            pointHoverBackgroundColor: "rgba(0, 155, 215, 0.75)",
                            pointHoverBorderColor: "rgba(0, 155, 215, 1)",
                            data: response.data.spend,
                            yAxisID: 'left-y',
                        }, {
                            label: 'Conversions',
                            backgroundColor: "rgba(229, 97, 73, 0.5)",
                            borderColor: "rgba(229, 97, 73, 0.8)",
                            pointHoverBackgroundColor: "rgba(229, 97, 73, 0.75)",
                            pointHoverBorderColor: "rgba(229, 97, 73, 1)",
                            data: response.data.conversions,
                            yAxisID: 'right-y',
                        }]
                    },
                    options: {
                        legend: {
                            display: false
                        },
                        animation: {
                            onComplete(animation) {
                                if (sendEvent) {
                                    Bus.$emit('chart-is-ready');
                                    sendEvent = false;
                                }
                            }
                        },
                        // title: {
                        //     display: true,
                        //     text: 'Daily Metrics'
                        // },
                        scales: {
                            yAxes: [{
                                id: 'left-y',
                                position: 'left',
                                scaleLabel: {
                                    // display: true,
                                    labelString: 'Spend'
                                },
                                ticks: {
                                    callback: function(value, index, values) {
                                        return value.toLocaleString("en-US", {
                                            style: "currency",
                                            currency: "USD"
                                        });
                                    }
                                }
                            }, {
                                id: 'right-y',
                                position: 'right',
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    min: 0
                                },
                                scaleLabel: {
                                    // display: true,
                                    labelString: 'Conversions'
                                }
                            }]
                        }
                    }
                });
                this.legend = this.pacingChart.generateLegend();
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/charts/DailyClientMetricsLineChart.vue